'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import MaterialCheckbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
const StyledCheckbox = styled(MaterialCheckbox)(({ theme }) => ({
    height: '1.875rem',
    width: '2.125rem',
    marginLeft: theme.spacing(1),
    color: theme.tokens.FuelColorBorderDark,
    boxSizing: 'border-box',
    '&.MuiCheckbox-indeterminate': {
        color: theme.tokens.FuelColorBackgroundInteractiveDefaultBase
    },
    '&.Mui-focusVisible .MuiSvgIcon-root': {
        borderRadius: theme.shape.borderRadius,
        boxShadow: `inset 0 0 0 0.125rem ${theme.tokens.FuelColorFocused}`
    },
    '&:hover': {
        color: theme.tokens.FuelColorBrandPrimary,
        backgroundColor: 'transparent'
    },
    '&.Mui-disabled': {
        color: theme.tokens.FuelColorTextDisabled
    },
    '&.Mui-disabled, &[aria-readonly="true"]': {
        cursor: 'default',
        pointerEvents: 'none'
    }
}));
export const Checkbox = forwardRef(({ onClickCapture, ...props }, ref) => {
    const handleClickCapture = (event) => {
        if (props.readOnly) {
            event.preventDefault();
        }
        onClickCapture?.(event);
    };
    return (_jsx(StyledCheckbox, { ...props, "aria-readonly": props.readOnly, onClickCapture: handleClickCapture, ref: ref }));
});
Checkbox.displayName = 'Checkbox';
